const apiUrl = process.env.REACT_APP_API_URL

export async function getClasses() {
    const token = localStorage.getItem('token')
    const userId = localStorage.getItem('userId')

    const response = await fetch(`${apiUrl}/class?teacher_id=${userId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    })

    if (!response.ok) {
        throw new Error('Failed to fetch classes')
    }

    const classes: { classes: Class[] } = await response.json()
    return classes
}

export async function renameClass(classId: number, newName: string) {
    const token = localStorage.getItem('token')

    if (!token) {
        throw new Error('User not authenticated')
    }

    const response = await fetch(`${apiUrl}/class/${classId}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ class_name: newName }),
    })

    if (!response.ok) {
        throw new Error('Failed to rename class')
    }

    const updatedClass: Class = await response.json()
    return updatedClass
}

export async function deleteClass(classId: number) {
    const token = localStorage.getItem('token')

    if (!token) {
        throw new Error('User not authenticated')
    }

    const response = await fetch(`${apiUrl}/class/${classId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    })

    if (!response.ok) {
        throw new Error('Failed to delete class')
    }

    return true
}

export default async function postClass(body: ClassRequest) {
    const token = localStorage.getItem('token')
    const response = await fetch(`${apiUrl}/class`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
    })

    const registerResponse: RegisterResponse = await response.json()

    return registerResponse
}

export interface Class {
    id: number
    class_name: string
    teacher_id: number
    created_at?: string
    updated_at?: string
}
interface RegisterResponse {
    classId: number
}

interface ClassRequest {
    classname: string
    teacher_id: number
}
